function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

export default memoize;
//# sourceMappingURL=memoize.esm.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/@emotion/memoize/dist/memoize.esm.js
// module id = 246
// module chunks = 0